import React from 'react';

/**
 * Form field container with label
 */
export function Field({ label, children, ...rest }) {
  return (
    <div className="field-container" {...rest}>
      <div className="module-header">{label}</div>
      <div className="module-rule" />
      <div>{children}</div>
    </div>
  );
}

/**
 * Small hint text below inputs
 */
export function Hint({ children }) {
  return <div className="mt-2 text-[11px] text-white/45">{children}</div>;
}
